import { css } from 'glamor';
import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import { SwitchInputProps } from '../input/basicInputs';
import classNames from 'classnames';
import { Classes } from '@blueprintjs/core';
import SwitchInput from '../input/basicInputs/SwitchInput';

const formFieldClassName = classNames(Classes.FORM_GROUP, css({ margin: 0 }).toString());

class SwitchInputFormField extends React.Component<BaseFormFieldProps & SwitchInputProps> {
  render() {
    // @ts-ignore
    const { label, ...otherProps } = this.props;
    return (
      <FormField {...otherProps} className={formFieldClassName} type="Switch">
        {({ input }) => (
          <SwitchInput
            {...input}
            onChange={(e) => {
              input.onChange(e);
              if (this.props.onChange) {
                this.props.onChange(e);
              }
            }}
            label={label}
          />
        )}
      </FormField>
    );
  }
}

export default SwitchInputFormField;
